const parseLinkLabel = require('markdown-it/lib/helpers/parse_link_label');

module.exports = function span(md) {
  md.inline.ruler.push('span', function replace(state, silent) {
    const prefix = '[';
    const start = state.pos;
    const max = state.posMax;

    if (state.src.charAt(start) !== prefix) {
      return false;
    }

    const classNameStart = state.pos + 1;
    const classNameEnd = parseLinkLabel(state, state.pos + 1, false);
    if (classNameEnd < 0) {
      return false;
    }

    const className = state.src.slice(classNameStart, classNameEnd);
    const closer = `[/${className}]`;

    state.pos = classNameEnd + 1;

    let pos = state.pos;
    let closerPos = false;
    while (pos < max) {
      const candidate = state.src.slice(pos, pos + closer.length);
      if (candidate === closer) {
        closerPos = pos;
        break;
      }

      pos++;
    }

    if (!closerPos) {
      state.pos = start;

      return false;
    }

    state.posMax = closerPos;
    state.pos = start + className.length + 2;

    if (!silent) {
      let token = state.push('span_open', 'span', 1);
      token.attrs = [['class', className]];

      state.md.inline.tokenize(state);

      token = state.push('span_close', 'span', -1);
    }

    state.pos = closerPos + closer.length;
    state.posMax = max;

    return true;
  });
};
